import { createAggrApiInstance } from '@/utils/api/axiosInstance'

import * as aggr from '@/api-generator/aggr/index'

const identityPickerApi = createAggrApiInstance(aggr.CommonIdentityPickerApi)

export const getIdentities = async (
  term: string,
  type: aggr.IdentityPickerType = aggr.IdentityPickerType.None,
  companyUuid?: string
) => {
  const res = await identityPickerApi.identitypickerIdentities(term, type, companyUuid)
  return res
}
